import { useState } from "react";

export function useSchemaHistory(initialSchema) {
  const [history, setHistory] = useState([initialSchema]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const current = history[currentIndex];

  const updateSchema = (newSchema) => {
    history.splice(currentIndex + 1); // remove any redo steps
    history.push(newSchema); // mutate by pushing
    setHistory([...history]); // trigger re-render
    setCurrentIndex(history.length - 1);
  };

  const undo = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const redo = () => {
    if (currentIndex < history.length - 1) setCurrentIndex(currentIndex + 1);
  };

  const reset = () => {
    history.length = 1;
    history[0] = initialSchema;
    setHistory([...history]); // re-render
    setCurrentIndex(0);
  };

  const clearHistoryBeforeCurrent = () => {
    if (currentIndex > 0) {
      history.splice(0, currentIndex); // remove elements before current
      setCurrentIndex(0);
      setHistory([...history]); // trigger re-render
    }
  };

  return {
    currentSchema: current,
    updateSchema,
    undo,
    redo,
    reset,
    clearHistoryBeforeCurrent,
    canUndo: currentIndex > 0,
    canRedo: currentIndex < history.length - 1,
    currentIndex,
  };
}
